import React, { useState } from 'react'
import moment from 'moment'
import { request } from 'meinian-package/src/utils'
import versionNumber from 'meinian-package/src/component/useFunModal/versionNumber'
import useVersionNumber from 'meinian-package/src/common/hooks/useVersionNumber'
import DownloadCenter from 'component/download'

export default (props) => {
  const { fileName, onChange, children, id } = props
  const [isLoading, setIsLoading] = useState(false)
  const { isAuthLimit } = useVersionNumber()
  const _onClick = async () => {
    if (isLoading) return
    if (!isAuthLimit('meinian_report_export_limit')) {
      versionNumber({
        title: '报表导出'
      })
      return
    }
    setIsLoading(true)
    const name = `${fileName}_导出时间${moment().format('YYYY-MM-DD_HH时mm分ss秒')}`
    await request.post('/zhikuan/mn/export/inspiration/export-task', {
      collectIdList: [id],
      fileName: name,
    })
    DownloadCenter.start({ type: 0 })
    onChange && onChange()
    setIsLoading(false)
  }
  return <div onClick={() => _onClick()}>
    {children || '导出'}
  </div>
}
